const hostOf = req => {
  const host = process.browser
    ? window.location.host
    : req.headers['x-forwarded-host'] || req.headers.host;
  return host;
};
export default hostOf;
